import { displayInfoFeedbackMessage } from '../utilities';
import MediaLibraryArchiveStorage from './storage-archive';
import MediaLibraryClient from '../clients/MediaLibraryClient';

class MediaLibraryDownloadFeedback
{
    constructor()
    {
        // Imports
        this._mediaLibraryClient = new MediaLibraryClient();
        this._mediaLibraryArchiveStorage = new MediaLibraryArchiveStorage();

        // Selectors
        this._downloadProgressContainerSelector = '.js-media-library__feedback-message--progress';
        this._downloadProgressBarSelector = '.js-media-library__progress-bar--download-selection';
        this._downloadProgressPercentageSelector = '.js-media-library__progress-percentage--download-selection';
        this._downloadCompletedContainerSelector = '.js-media-library__feedback-message--completed';

        // Download
        this._downloadPath = 'https://downloads.orion-wholesale.com/prepared/';

        // Feedback
        this._downloadProgressFeedback = document
            .querySelector('meta[name="feedback.media.library.collection.download.progress"]')
            .getAttribute('content');
        this._downloadCompletedFeedback = document
            .querySelector('meta[name="feedback.media.library.collection.download.completed"]')
            .getAttribute('content');
        this._downloadFailedFeedback = document
            .querySelector('meta[name="feedback.media.library.collection.download.failed"]')
            .getAttribute('content');

        // Helper
        this._progressFeedbackIsActive = false;
    }

    init()
    {
        this._customerId = orion.getCustomerId();

        if (this._mediaLibraryArchiveStorage.checkStorage(this._customerId))
        {
            this.initLoadingState();
        }
    }

    initLoadingState()
    {
        let data = this._mediaLibraryArchiveStorage.getStorage(this._customerId);

        this.checkDownloadStatus(this._downloadPath + data.jsonPath);
    }

    initProgressFeedbackEvent()
    {
        document.querySelector(this._downloadProgressContainerSelector)
            .closest('.js-feedback').addEventListener('click', () =>
            {
                this._progressFeedbackIsActive = false;

                sessionStorage.setItem('ml-feedback-progress-hidden', 'true');
            });
    }

    initCompletedFeedbackEvent()
    {
        document.querySelector(this._downloadCompletedContainerSelector)
            .closest('.js-feedback').addEventListener('click', () =>
            {
                sessionStorage.setItem('ml-feedback-completed-hidden', 'true');
            });
    }

    removeProgressFeedbackMessage()
    {
        let feedbackMessage = document.querySelector(this._downloadProgressContainerSelector).closest('.js-feedback');

        feedbackMessage.remove();
    }

    /**
	 * @param {string} jsonPath json path
	 */
    checkDownloadStatus(jsonPath)
    {
        this._mediaLibraryClient.fetchProgressJson(jsonPath)
            .then(response => response.json())
            .then(json =>
            {
                if (json.downloadFile === '')
                {
                    if (sessionStorage.getItem('ml-feedback-completed-hidden') === 'true')
                    {
                        sessionStorage.removeItem('ml-feedback-completed-hidden');
                    }
                    if (sessionStorage.getItem('ml-feedback-progress-hidden') !== 'true')
                    {
                        if (!this._progressFeedbackIsActive)
                        {
                            displayInfoFeedbackMessage(this._downloadProgressFeedback);
                            this.initProgressFeedbackEvent();
                            this._progressFeedbackIsActive = true;
                        }
                        this.updateProgressBar(json.progressPercentage);
                    }

                    setTimeout(() =>
                    {
                        this.checkDownloadStatus(jsonPath);
                    }, 1000);
                }
                else
                {
                    if (this._progressFeedbackIsActive)
                    {
                        this.removeProgressFeedbackMessage();
                    }
                    if (sessionStorage.getItem('ml-feedback-completed-hidden') !== 'true')
                    {
                        displayInfoFeedbackMessage(this._downloadCompletedFeedback);
                        this.initCompletedFeedbackEvent();
                    }
                    sessionStorage.removeItem('ml-feedback-progress-hidden');
                }
            })
            .catch(() =>
            {
                if (this._progressFeedbackIsActive)
                {
                    this.removeProgressFeedbackMessage();
                }
                this._mediaLibraryArchiveStorage.removeStorage(this._customerId);
            });
    }

    /**
	 * @param {number} progressPercentage Progress percentage
	 */
    updateProgressBar(progressPercentage)
    {
        let progressPercentageString = Math.round(progressPercentage) + '%';

        document.querySelector(this._downloadProgressBarSelector).style.width = progressPercentageString;
        document.querySelector(this._downloadProgressPercentageSelector).innerText = progressPercentageString;
    }
}

if (document.querySelector('body').classList.contains('authorized')
    && !document.querySelector('#media-library-search')
    && !document.querySelector('#media-library-collection'))
{
    let mediaLibraryDownloadFeedback = new MediaLibraryDownloadFeedback();

    mediaLibraryDownloadFeedback.init();
}
